'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _sparkCore = require('@ciscospark/spark-core');

var _constants = require('../constants');

var _collection = require('./collection');

var _collection2 = _interopRequireDefault(_collection);

var _request = require('./request');

var _request2 = _interopRequireDefault(_request);

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class MeetingInfo
 */
var MeetingInfo = function (_StatelessSparkPlugin) {
  (0, _inherits3.default)(MeetingInfo, _StatelessSparkPlugin);

  /**
   *
   * @param {Object} attrs
   * @param {Object} options
   */
  function MeetingInfo(attrs, options) {
    (0, _classCallCheck3.default)(this, MeetingInfo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MeetingInfo.__proto__ || (0, _getPrototypeOf2.default)(MeetingInfo)).call(this, {}, options));

    _this.namespace = _constants.MEETINGS;

    _this.meetingInfoRequest = new _request2.default({}, options);
    return _this;
  }

  /**
   * @param {string} id
   * @returns {object}
   * @memberof MeetingInfo
   */


  (0, _createClass3.default)(MeetingInfo, [{
    key: 'fetchMeetingInfo',


    /**
     * Fetches meeting info from the server
     * @param {String} destination one of many different types of destinations to look up info for
     * @param {String} type optional type to match up with the destination value
     * @returns {Promise} returns a meeting info object
     */
    value: function fetchMeetingInfo(destination) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var options = _util2.default.generateOptions({
        destination: destination,
        type: type,
        conversationServiceUrl: this.spark.internal.device.services.conversationServiceUrl
      });
      return this.meetingInfoRequest.fetchMeetingInfo(options).then(function (info) {
        MeetingInfo.setMeetingInfo(info.id, info);
        return info;
      }).catch(function (error) {
        return error;
      });
    }
  }], [{
    key: 'getMeetingInfo',
    value: function getMeetingInfo(id) {
      return _collection2.default.get(id);
    }

    /**
     * @param {string} id
     * @param {object} info
     * @returns {null}
     * @memberof MeetingInfo
     */

  }, {
    key: 'setMeetingInfo',
    value: function setMeetingInfo(id, info) {
      _collection2.default.set(id, info);
    }
  }]);
  return MeetingInfo;
}(_sparkCore.StatelessSparkPlugin); /*!
                                     * Copyright (c) 2015-2018 Cisco Systems, Inc. See LICENSE file.
                                     */

exports.default = MeetingInfo;
//# sourceMappingURL=index.js.map
